import { grey } from "@mui/material/colors";

const styles = {
  select: {
    backgroundColor: "white",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: grey[300],
      borderRadius: 4,
    },
  },
};
export default styles;
